module.exports = "/images/830e344cac448909547b79e2f08f1340.svg";